import { render, staticRenderFns } from "./marketersData.vue?vue&type=template&id=1db2496b&scoped=true"
import script from "./marketersData.vue?vue&type=script&lang=js"
export * from "./marketersData.vue?vue&type=script&lang=js"
import style0 from "./marketersData.vue?vue&type=style&index=0&id=1db2496b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db2496b",
  null
  
)

export default component.exports